import { render, staticRenderFns } from "./cells.vue?vue&type=template&id=6bee97f2&scoped=true&"
import script from "./cells.vue?vue&type=script&lang=js&"
export * from "./cells.vue?vue&type=script&lang=js&"
import style0 from "./cells.vue?vue&type=style&index=0&id=6bee97f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bee97f2",
  null
  
)

export default component.exports